import React from 'react';
import './ModularHalls.css';

const ModularHalls: React.FC = () => {
  const products = [
    {
      title: 'Teleskopik Konferans Salonları',
      description: 'İhtiyaca göre açılıp kapanabilen teleskopik sistemler',
      image: 'https://static.wixstatic.com/media/e733f0_bc17f28857f4468fad5ebe1abebfb89df002.jpg/v1/fill/w_480,h_480,al_c,q_80,enc_avif,quality_auto/e733f0_bc17f28857f4468fad5ebe1abebfb89df002.jpg'
    },
    {
      title: 'Çok Amaçlı Modüler Salonlar',
      description: 'Farklı etkinliklere uyarlanabilen esnek salon çözümleri',
      image: 'https://static.wixstatic.com/media/e733f0_8bfd13daf2ae4bdd9f3d5a6e592ad6e0f002.jpg/v1/fill/w_480,h_480,al_c,q_80,enc_avif,quality_auto/e733f0_8bfd13daf2ae4bdd9f3d5a6e592ad6e0f002.jpg'
    },
    {
      title: 'Sehpalı - Amfi Tip Salonlar',
      description: 'Basamaklı ve sehpalı oturma düzenleri ile amfi tip salonlar',
      image: 'https://static.wixstatic.com/media/e733f0_c49449c4307a45d7b34d2c43e940f78f~mv2.jpg/v1/fill/w_504,h_504,al_c,lg_1,q_80,enc_avif,quality_auto/e733f0_c49449c4307a45d7b34d2c43e940f78f~mv2.jpg'
    }
  ];

  const technologies = [
    {
      title: 'Hareketli Zemin Platformları',
      description: 'Salon zeminleri, hidrolik veya mekanik sistemlerle yükseltilip alçaltılabilir. Bu sayede aynı mekân, gerektiğinde düz zeminli bir fuar alanı, gerektiğinde basamaklı bir oditoryum haline gelir.'
    },
    {
      title: 'Teleskopik Tribün Sistemleri',
      description: 'İhtiyaca göre açılıp kapanabilen oturma tribünleri sayesinde kapasite artırılabilir veya boşaltılabilir. Tribünler kullanılmadığında toplanarak mekânda geniş bir açık alan elde edilir.'
    },
    {
      title: 'Katlanabilir ve Kaldırılabilir Koltuklar',
      description: 'Koltukların tamamen kaldırılabilir veya zemine gömülebilir şekilde tasarlanması, mekânın çok kısa sürede farklı fonksiyonlara uyarlanmasını sağlar. Böylece tek bir salon, hem spor etkinlikleri hem de akademik konferanslar için kullanılabilir.'
    }
  ];

  const advantages = [
    {
      title: 'Maksimum Mekân Kullanımı',
      description: 'Tek bir salon, çok sayıda etkinliğe ev sahipliği yapar.'
    },
    {
      title: 'Ekonomik Kazanç',
      description: 'Yatırım maliyeti tek bir proje için değil, onlarca farklı senaryo için geri dönüş sağlar.'
    },
    {
      title: 'Sürdürülebilirlik',
      description: 'Daha az inşaat, daha çok kullanım. Kaynakların verimli değerlendirilmesiyle çevreye katkı sağlar.'
    },
    {
      title: 'Esnek Organizasyon İmkanı',
      description: 'Farklı etkinliklere hızlı geçiş yapılabilir, zamandan ve iş gücünden tasarruf edilir.'
    },
    {
      title: 'Prestij',
      description: 'Modern şehirlerin, üniversitelerin ve kültür merkezlerinin ihtiyaç duyduğu çağdaş bir vizyon ortaya konur.'
    }
  ];

  const useCases = [
    {
      title: 'Üniversiteler',
      description: 'Konferans + spor etkinlikleri için dönüşebilen salonlar.'
    },
    {
      title: 'Belediyeler',
      description: 'Kültür merkezlerinde konser, tiyatro ve seminerleri tek mekânda organize edebilme.'
    },
    {
      title: 'Spor Salonları',
      description: 'Uluslararası standartlarda teleskopik tribünlerle esnek kapasite yönetimi.'
    },
    {
      title: 'Çok Amaçlı Salonlar',
      description: 'Düğün, kongre, konser ve toplantıların aynı mekânda yapılabilmesi.'
    }
  ];

  return (
    <div className="modular-halls-page">
      <div className="page-container">
        <div className="page-header">
          <h1>Modüler - Teleskopik Salonlar</h1>
        </div>

        <div className="products-grid">
          {products.map((product, index) => (
            <div key={index} className="product-card">
              <div className="product-image">
                <img src={product.image} alt={product.title} />
              </div>
              <h3>{product.title}</h3>
              <p>{product.description}</p>
            </div>
          ))}
        </div>

        <section className="main-section">
          <h2>Nish Flex – Modüler ve Teleskopik Salon Sistemleri</h2>
          <div className="intro-content">
            <p>
              Geleneksel salonlar, çoğu zaman tek bir amaç için tasarlanır ve inşa edilir. Oysa 
              günümüz şehirlerinde ve kurumlarında ihtiyaçlar sürekli değişiyor. Bir mekânın sabah 
              konferans salonu, öğlen spor salonu, akşam ise konser veya tiyatro salonu olarak 
              kullanılabilmesi, yatırımın gerçek değerini ortaya çıkarır. İşte bu anlayışla geliştirdiğimiz 
              Nish Flex – Modüler ve Teleskopik Salon Çözümleri, mekânları dinamik, çok amaçlı ve 
              sürdürülebilir hale getiriyor.
            </p>
          </div>
        </section>

        <section className="technologies-section">
          <h2>Teknolojinin Sağladığı Esneklik</h2>
          <div className="technologies-list">
            {technologies.map((tech, index) => (
              <div key={index} className="tech-item">
                <h3>{index + 1}. {tech.title}</h3>
                <p>{tech.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="advantages-section">
          <h2>Yatırımcıya Sağladığı Avantajlar</h2>
          <div className="advantages-list">
            {advantages.map((advantage, index) => (
              <div key={index} className="advantage-item">
                <h3>→ {advantage.title}</h3>
                <p>{advantage.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="use-cases-section">
          <h2>Kullanım Alanları</h2>
          <div className="use-cases-list">
            {useCases.map((useCase, index) => (
              <div key={index} className="use-case-item">
                <h3>• {useCase.title}</h3>
                <p>{useCase.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="difference-section">
          <h2>Nish Global'in Farkı</h2>
          <p>
            Nish Global, modüler salon çözümlerinde yalnızca teknolojiyi uygulayan bir firma değil; 
            aynı zamanda tüm süreci anahtar teslim olarak planlayan ve yöneten bir mühendislik markasıdır. 
            Projenin ilk çiziminden son montajına kadar, her aşamada uluslararası standartlar ve Türk 
            mühendisliğinin kalitesi ön planda tutulur.
          </p>
          <p>
            Nish Flex, bugünün değil, geleceğin ihtiyaçlarını karşılayan yenilikçi çözümdür.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ModularHalls;
